import styled, { css } from 'styled-components';
import { rem } from '~/src/helpers/rem-converter.helper';
import { mediaQuery } from '~/src/styles/mixins';
import { MAX_567 } from '~/src/styles/tokens/break-points';
import { COLORS } from '~/src/styles/tokens/colors';
import { Z_INDEX } from '~/src/styles/tokens/z-index';
import { BORDER_RADIUS } from '~/src/styles/tokens/border-radius';

const FullScreenStyles = css`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
`;

export const PopupBackground = styled.div<{ isOpen: boolean; }>`
    ${FullScreenStyles};
    z-index: ${Z_INDEX.level2};
    background-color: ${COLORS.backgroundLightOverlay};
    opacity: ${(p) => (p.isOpen ? '.6' : '0')};
    visibility: ${(p) => (p.isOpen ? 'visible' : 'hidden')};
    transition: all 225ms cubic-bezier(.4, 0, .2, 1) 0ms;
`;

export const PopupWindow = styled.div<{ noSidePadding?: boolean; }>`
    position: relative;
    z-index: ${Z_INDEX.level3};
    height: 100%;
    padding: ${rem(24)};
    border-radius: ${BORDER_RADIUS.big16};
    background-color: ${COLORS.backgroundModal};

    ${mediaQuery({ maxWidth: MAX_567 }, css`
        padding: ${rem(20)};
    `)};
`;

export const PopupBaseLayer = styled.div`
    position: relative;
    ${FullScreenStyles};
    z-index: ${Z_INDEX.top};
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    min-width: ${rem(288)};
    box-sizing: border-box;
    backdrop-filter: blur(4px);
`;

export const PopupWrap = styled.div`
    position: relative;
    bottom: 0;
    padding: ${rem(24)};

    ${mediaQuery({ maxWidth: MAX_567 }, css`
        padding: ${rem(16)};
    `)};
`;

export const CloseWrapper = styled.div`
    position: absolute;
    ${Z_INDEX.level5};
    top: 0;
    right: -${rem(20)};
    cursor: pointer;

    path {
        fill: ${COLORS.constantGreyscale0};
    }
`;
